import { Settings } from '@/types'
import { App } from 'vue'
import VueGtag from 'vue-gtag'
export { event } from 'vue-gtag'

export default {
  install(app: App<Element>, settings: Settings) {
    if (import.meta.env.MODE === 'production') {
      const googleTagIdIsDefined = !!settings.googleAnalyticsKey
      if (googleTagIdIsDefined) {
        app.use(VueGtag, {
          config: {
            id: settings.googleAnalyticsKey ?? ''
          }
        })
      }
    }
  }
}
